import React, {useEffect} from 'react';
import {
	Typography,
	Grid,
} from "@material-ui/core";
import { useStyles } from "../../../hooks";
import styles from "./styles";
import { PUBLICURL } from "../../../main_config";
import {useDispatch} from "react-redux";
import { clearDataScheduler } from '../../../redux/actions/hireActions'

const UnsuccessfulHiring = ({...props}) => {
	const dispatch = useDispatch();
	const classes = useStyles(styles);

	const TypographyProps = {
		component: "h2",
		gutterBottom: true,
		color: "primary",
		align: "center"
	};	

	useEffect(()=> {
        dispatch(clearDataScheduler())
    },[])

	return (
		<Grid container className={classes.container}>
			<Grid container direction="row"
				justifyContent="center"
				alignItems="center"
				style={{marginTop: 50}}
			>
				<Typography
					{...TypographyProps}
					className={classes.title}

				>
					{props?.location?.state?.message ? props?.location?.state?.message : "Lamentablemente, no podemos brindarte el plan solicitado."}
			</Typography>
			</Grid>

			<Grid container direction="row"
				justifyContent="center"
				alignItems="center"
				className={classes.containerImg}
				style={{marginTop: 50}}
			>

				<img
					src={`${PUBLICURL}/assets/images/hire/HireUnsuccess.png`}
					alt="Exito"
				/>
			</Grid>
		</Grid>
	);
}

export default UnsuccessfulHiring;